module.exports = __webpack_public_path__ + "img/type_3.77fab91f.png";